import React from 'react';
import { API }     from 'aws-amplify';
import styled from 'styled-components';
import CustomTextField from './CustomTextField';

import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
  } from 'semantic-ui-react'

  
  const blueColor = "#296aac";
  const darkBlue = "#013153";
 
const Styles = styled.div`
    background: var(--gradient-primary);
    min-height: 100vh;
    padding: 6rem 0 4rem;

    h1 {
        font-family: 'Sora', sans-serif;
        font-size: 3rem;
        font-weight: 800;
        color: var(--color-text);
        margin-bottom: 1rem;
        letter-spacing: 0;
    }

    h2 {
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 1.3rem;
        font-weight: 300;
        color: var(--color-text-muted);
        line-height: 1.6;
        margin-bottom: 2rem;
    }

    .ui.segment {
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
    }

    .message-box {
        margin-top: 20px;
        padding: 15px 20px;
        border-radius: 8px;
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 1rem;
        line-height: 1.5;
        animation: slideIn 0.3s ease-out;
    }

    .message-success {
        background: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
    }

    .message-error {
        background: #f8d7da;
        color: #721c24;
        border: 1px solid #f5c6cb;
    }

    .message-validation {
        background: #fff3cd;
        color: #856404;
        border: 1px solid #ffeaa7;
    }

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`


function Contact(props) {

    const [, updateState] = React.useState();
    const [formData, setFormData] = React.useState({
        name:"",
        email:"",
        message:""
    });

    const [inputError, setInputError] = React.useState({name:false, email:false, message:false});

    const [loading, setLoading] = React.useState(false);
    const [submitMessage, setSubmitMessage] = React.useState({ type: null, text: '' }); // {type: 'success'|'error'|'validation', text: ''}

    const forceUpdate = React.useCallback(() => updateState({}), []);

    function validateFormData() {

        var Namere = /[A-Za-z]{1}[A-Za-z]/;
        if (!Namere.test(formData.name)) {
            setInputError({...inputError, name: true});
            return false;
        }
        if (formData.email=="") {
            setInputError({...inputError, email: true});
            return false;
        }
        var reeamil = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/;
        if (!reeamil.test(formData.email)) {
            setInputError({...inputError, email: true});
            return false;
        }

        return true;
    }


return (
    <Styles>

         <div>
         <Segment vertical style={{paddingTop:"0em"}}>

 <Grid container stackable verticalAlign='middle'>      

 <Grid.Row style={{paddingLeft:"", paddingTop:"8em", paddingBottom:"8em"}}>

      <Grid.Column width={5}>

      <h1>Contact</h1>

        <h2>Fill out the contact form and we will contact you.</h2>


        <CustomTextField   
                    className="search-input"
                    style={{float:"left", minWidth:"20em"}}              
                    properties={
                    {
                        name:"Name",
                        error:inputError.name,
                        rows:1
                    }
                    }
                    defaultValue={formData.name}
                    inputProps={{
                        'aria-label': 'Seller ID',
                    }}
                    onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        console.log("Key enter Seller ID");
                    }
                }}
                onChange= {            
                    e =>
                    { 
                        setFormData({...formData, name:e.target.value});
                        if (e.target.value) {
                            setInputError({...inputError, name:false});
                        }
                    }
                }/>   


<CustomTextField   
                    className="search-input"
                    style={{float:"left", minWidth:"20em"}}              
                    properties={
                    {
                        name:"Email",
                        error:inputError.email,
                        rows:1
                    }
                    }
                    defaultValue={formData.email}
                    inputProps={{
                        'aria-label': 'email',
                    }}
                    onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        console.log("Key enter email");
                    }
                }}
                onChange= {            
                    e =>
                    { 
                        setFormData({...formData, email:e.target.value});
                        if (e.target.value) {
                            setInputError({...inputError, email:false});
                        }
                    }
                }/>

            <CustomTextField   
                    className="search-input"
                    style={{float:"left", minWidth:"20em", minHeight:"30em"}}              
                    properties={
                    {
                        name:"Message",
                        error:inputError.message,
                        rows:10
                    }
                    }
                    defaultValue={formData.message}
                    inputProps={{
                        'aria-label': 'message',
                    }}
                    onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        console.log("Key enter message");
                    }
                }}
                onChange= {            
                    e =>
                    { 
                        setFormData({...formData, message:e.target.value});
                        if (e.target.value) {
                            setInputError({...inputError, message:false});
                        }
                    }
                }/>  

        <form id="contact-form" method="post">
        
        <div data-sitekey="" className="form-control" style={{width:"100%"}}></div>
        {submitMessage.type && (
            <div className={`message-box message-${submitMessage.type}`}>
                {submitMessage.text}
            </div>
        )}

        <Button primary loading={loading} type="button" className="btn btn-lg" style={{marginTop:"35px"}}
        onClick={async ()=>{
            console.log('Submit button clicked');
            console.log('Form data:', formData);

            if (!loading) {
                setLoading(true);
                setSubmitMessage({ type: null, text: '' });

                if (validateFormData()) {
                    try {
                        console.log('Validation passed, sending API request...');
                        let params = {body:{...formData}};
                        const apiResponse = await API.post('Contact' , '/app/submit', params);
                        console.log('API Response:', apiResponse);

                        setLoading(false);
                        if (apiResponse) {
                            setSubmitMessage({
                                type: 'success',
                                text: 'Thank you! Your message has been sent successfully. We will contact you soon.'
                            });
                            setFormData({
                                name:"",
                                email:"",
                                message:""
                            });
                        }
                    } catch (error) {
                        console.error('API Error:', error);
                        setLoading(false);
                        setSubmitMessage({
                            type: 'error',
                            text: `Error sending message: ${error.message || 'Please try again later.'}`
                        });
                    }
                } else {
                    console.log('Validation failed');
                    console.log('Input errors:', inputError);
                    setLoading(false);

                    let errorMsg = 'Please fix the following: ';
                    let errors = [];
                    if (inputError.name) errors.push('Name must be at least 2 letters');
                    if (inputError.email) errors.push('Valid email required');
                    if (inputError.message) errors.push('Message is required');

                    setSubmitMessage({
                        type: 'validation',
                        text: errors.length > 0 ? errorMsg + errors.join(', ') : 'Please fill out all required fields correctly.'
                    });
                }
            }
        }} >Submit</Button>
        </form>
    
      </Grid.Column>
  </Grid.Row>
</Grid>



</Segment>


         </div>

    </Styles>
)


}

export default Contact
